module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hedo-intro-card1.1@2x.0df725ad.jpg";